import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import MidtermAndFinalExamHFv4, { mapStateToProps } from './component';

import { routes as progressTestDayView } from '../ProgressTest/ProgressTestDayView';
import { routes as progressTestCourseView } from './CourseView';
import { routes as progressTestRubricView } from './RubricView';
import ViewNavHFv4 from './ViewNavHFv4';
import ProgressTestSessionNavHFv4 from './ProgressTestSessionNavHFv4';

const isAccessable = (state, groupId) => {
  const hasPrivilege = PrivilegeChecker.hasPrivilege(state, Privileges.ProgressTest.View);
  const isTabEnabled = TabSwitcher.isTabEnabled(state, groupId, TabCodes.AssessmentHFv4);
  const progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  if (! progressTestsPlan || ! progressTestsPlan.data) {
    return hasPrivilege && isTabEnabled;
  }

  const hasMidtermOrFinalExam = progressTestsPlan && progressTestsPlan.data &&
    progressTestsPlan.data.find((ptp) => ptp.isUnitQuiz === false);

  return hasPrivilege && isTabEnabled && hasMidtermOrFinalExam;
};

export default ({ getState }) => ({
  appBars: {
    sticky: {
      ptNav: {
        component: ProgressTestSessionNavHFv4,
        props: {
          isUnitQuiz: false,
        },
        order: 1,
      },
      'view-nav': {
        component: ViewNavHFv4,
        props: {
          showExpandable: true,
        },
        order: 3,
      },
    },
  },
  path: 'exam-hfv4',
  component: MidtermAndFinalExamHFv4,
  canAccess: ({ params }) => isAccessable(getState(), params.groupId),
  tab: {
    label: 'Assessment',
    order: 6,
    isVisible: (params) => isAccessable(getState(), params.groupId),
  },
  breadcrumbLabels: (props) => {
    const { params: { groupId, progressTestIndex }, buildRoute } = props;
    const currentProps = mapStateToProps(getState(), props);
    if (! currentProps || ! currentProps.currentProgressTestPlan) return;
    return {
      label: currentProps.currentProgressTestPlan.name,
      href: buildRoute(`/group/${groupId}/exam-hfv4/${progressTestIndex}/course`),
    };
  },
  childRoutes: [
    progressTestDayView,
    progressTestCourseView,
    progressTestRubricView,
  ],
});


// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/routes.js